<template>
  <div class="lets-three-view">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small">
      <div class="white-container">
        <!-- <el-form-item label="活动类别" prop="activityCategory" style="width: 300px">
          <el-select v-model="form.activityCategory" placeholder="请选择活动类别" :disabled="disabled">
            <el-option v-for="item in letsBasketballTypeSelectVOS" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item> -->

        <el-form-item label="活动主标题" prop="name" style="width: 500px">
          <el-input v-model="form.name" placeholder="请输入活动主标题，最多不超过14个字" maxlength="14" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="活动日期" prop="activityTime" style="width: 500px">
          <el-date-picker v-model="form.activityTime" type="datetimerange" placeholder="请选择活动时间" prefix-icon="el-icon-date" class="custom-date" start-placeholder="活动开始日期和时间" end-placeholder="活动结束日期和时间" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="开放报名时间" prop="differDay" style="width: 500px">
          <div class="flex tips">活动开始前
            <el-input v-model="form.differDay" placeholder="14" type="number" :min="0" :disabled="disabled" style="width:50px !important;margin: 0 10px" oninput="value=value.replace('/^[1-9]\d*$/','');if(value<0)value=0" @keydown.native="handleFixNaN" />天
          </div>
        </el-form-item>
        <el-form-item label="截止报名时间" prop="registrationIsOver" style="width: 500px">
          <div class="flex tips">活动开始前
            <el-input v-model="form.registrationIsOver" placeholder="01" type="number" :min="0" :disabled="disabled" style="width:50px !important;margin: 0 10px" oninput="value=value.replace('/^[1-9]\d*$/','')" @keydown.native="handleFixNaN" />天
          </div>
        </el-form-item>
        <div class="peopleNums">
          <el-form-item label="最大球队数" prop="maxTeam" style="width: 300px">
            <el-input v-model="form.maxTeam" type="number" placeholder="请输入最大球队数" maxlength="9" :disabled="disabled" @input="value => form.maxTeam = parseInt(value)" />
          </el-form-item>
          <el-form-item label="最小球队数" prop="minTeam" style="width: 300px">
            <el-input v-model="form.minTeam" type="number" placeholder="请输入最小球队数" maxlength="9" :disabled="disabled" @input="value => form.minTeam = parseInt(value)" @blur="checkMaxOrMinTeam('maxTeam')" />
          </el-form-item>
        </div>
        <el-form-item label="计算活动时长" prop="isCalculationDuration">
          <el-radio-group v-model="form.isCalculationDuration" :disabled="disabled">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="flex" style="flex-wrap:wrap;">
          <el-form-item label="活动城市" prop="uaEventCityId" style="width: 300px">
            <el-select ref="cityBox" v-model="form.uaEventCityId" placeholder="城市">
              <el-option v-for="item in citySelectVO" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item :key="1" label="活动地址" prop="otherAddress">
            <el-input v-model="form.otherAddress" placeholder="请输入活动地址" style="width:360px !important;margin-right:10px" />
          </el-form-item>
          <el-form-item style="margin-left:20px; margin-right:20px;" class="btn-form-item">
            <el-button type="primary" @click="openMap">打开地图</el-button>
          </el-form-item>
          <el-form-item :key="2" label="坐标" prop="location" class="lng-label">
            <el-input v-model="form.location" placeholder="请输入活动地址的经纬度" style="width: 200px !important;" />
          </el-form-item>
        </div>

        <!-- <el-form-item label="参赛流程" prop="entryProcess" style="width: 80%;margin-top: 10px;">
          <el-input v-model="form.entryProcess" type="textarea" :rows="4" placeholder="请输入该场活动的参赛流程" :disabled="disabled" />
        </el-form-item> -->
        <el-form-item label="是否在列表页展示" prop="isShow" label-width="140px">
          <el-radio-group v-model="form.isShow" :disabled="disabled">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传图片" prop="activityImageVO" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage :url="form.activityImageVO.activityListPagePicture" title="列表页图片" size-tips="360px*576px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'activityListPagePicture')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.activityImageVO.shareCardImage" title="小程序分享卡片" size-tips="500px*400px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'shareCardImage')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.activityImageVO.shareImage" title="海报分享图片" size-tips="849px*849px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'shareImage')" @triggerReg="handleCheckReg" />
          </div>
        </el-form-item>
        <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
          <div class="flex btns">
            <el-button type="info" @click="cancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { LetsBasketball } from '@/model/LetsBasketball';
import Dialog from '@/components/Dialog';
import UploadImage from '@/components/UploadImage';
export default {
  components: { Dialog, UploadImage },
  data() {
    return {
      formDialogShow: false,
      information: {},
      cancelTxt: '',
      form: new LetsBasketball(),
      rules: {
        // activityCategory: [
        //   { required: true, message: '请选择活动类型', trigger: 'change' },
        // ],
        name: [
          { required: true, message: '活动主标题', trigger: 'blur' },
        ],
        activityTime: [
          { type: 'array', required: true, message: '请输入活动时间', trigger: ['change', 'blur'] },
        ],
        isCalculationDuration: [
          { required: true, message: '请选择是否计算活动时长', trigger: 'change' },
        ],
        uaEventCityId: [
          { required: true, message: '请输入活动城市', trigger: 'change' },
        ],
        otherAddress: [
          { required: true, message: '请输入活动地址', trigger: 'blur' },
        ],
        location: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === '0,0') {
                callback(new Error('请输入经纬度'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        maxTeam: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === undefined || value === null) {
                callback(new Error('请输入最大球队数'));
              } else if (value && this.form.minTeam && value < this.form.minTeam) {
                callback(new Error('最大球队数小于最小球队数'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        minTeam: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === undefined || value === null) {
                callback(new Error('请输入最小球队数'));
              } else if (value && this.form.minTeam && value > this.form.maxTeam) {
                callback(new Error('最小球队数大于最大球队数'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        activityImageVO: {
          required: true, validator: (rule, value, callback) => {
            const keys = [
              { key: 'activityListPagePicture', label: '列表页图片' },
              // { key: 'activityDetailsPageHeader', label: '活动详情页头图' },
              { key: 'shareCardImage', label: '小程序分享卡片' },
              { key: 'shareImage', label: '海报分享图片' },
              // { key: 'recommendedPcturesOfRelevantActivities', label: '相关活动推荐图片' },
              // { key: 'myActivityListPictures', label: '我的活动列表页图片' },
            ];
            value.myActivityListPictures = ' ';
            value.recommendedPcturesOfRelevantActivities = ' ';

            for (const { key, label } of keys) {
              if (!value[key]) {
                callback(new Error(`请上传${label}`));
              }
            }
            callback();
          }, trigger: ['change'],
        },

      },
      savePath: 'ua_activity/letsBasketball/',
      disabled: false,
      letsBasketballTypeSelectVOS: [],
      cancelText: "",
    };
  },
  computed: {
    ...mapState('activity', ['citySelectVO']),
  },
  mounted() {
    const { query } = this.$route;
    this.id = query.id || query.copyId;
    this.cancelText = query.id ? '编辑' : '新增';
    if (query.id || query.copyId) {
      this.getLetsBasketballDetail(this.id);
    }
  },
  methods: {
    getLetsBasketballType() {
      this.$Api.letsBasketball.getLetsBasketballType().then(res => {
        this.letsBasketballTypeSelectVOS = res;
      });
    },
    getLetsBasketballDetail(id) {
      this.$Api.letsBasketball.getLetsBasketballDetail(id).then(res => {
        this.form = new LetsBasketball(res);
      });
    },
    addEditItem() {
      if (this.$route.query.copyId) {
        this.form.id = '';
      }

      if (this.cancelText === '新增') {
        this.$Api.letsBasketball.addLetsBasketball(this.form).then(res => {
          this.$message.success(`${this.cancelText}成功`);
          setTimeout(() => {
            this.$router.back(-1);
          }, 2000);
        }).catch(err => {
          if (err && !err.success) {
            console.error(err.errorMessage || `${this.cancelText}失败`);
          }
        });
      } else if (this.cancelText === '编辑') {
        this.$Api.letsBasketball.editLetsBasketball(this.form).then(res => {
          this.$message.success(`${this.cancelText}成功`);
          setTimeout(() => {
            this.$router.back(-1);
          }, 2000);
        }).catch(err => {
          if (err && !err.success) {
            console.error(err.errorMessage || `${this.cancelText}失败`);
            // this.$message.error(err.errorMessage || `${this.cancelText}失败`);
          }
        });
      }
    },
    // 测试最大最小团队数量/团队人数
    checkMaxOrMinTeam(key) {
      this.$refs.form.validateField([key], valid => {
        if (valid) {
          // 校验不通过
          return;
        }
      });
    },
    dialogSuccess(operation) {
      if (operation === 'cancel') {
        this.$router.go(-1);
      } else if (operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.addEditItem();
          } else {
            return false;
          }
        });
      }
    },
    handleFixNaN(e) {
      const { key } = e;
      if (key === 'e' || key === '.') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意活动状态，保存后已发布的活动信息将实时更新至UA HOUSE小程序",
      };
    },
    openMap() {
      window.open('https://lbs.qq.com/getPoint/');
    },
    uploader(file, key) {
      this.form.activityImageVO[key] = file;
      this.$forceUpdate();
    },
    handleCheckReg() {
      this.$refs.form.validateField("activityImageVO");
    },
  },
};
</script>
<style lang="less" scoped>
.lets-three-view {
  position: relative;
  .marginTop {
    margin-top: 30px;
  }
  .peopleNums {
    min-width: 1000px;
    display: flex;
    align-items: flex-start;
    .peopleNums-box {
      display: flex;
      align-items: flex-start;
    }
    button {
      margin-left: 30px;
    }
  }
  .coupon-uploader {
    margin: unset;
    display: flex;
    height: 34px;
    line-height: 34px;
    .el-button {
      width: 115px;
      height: 34px;
    }
    .coupon_tip {
      width: 250px;
      white-space: nowrap;
      margin-left: 10px;
      margin-right: 20px;
    }
    .download-file {
      white-space: nowrap;
    }
  }
  :deep(.lng-label .el-form-item__label) {
    width: 50px !important;
  }
  :deep(.lng-label .el-form-item__content) {
    margin-left: 50px !important;
  }
  :deep(.btn-form-item.el-form-item--small) {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  :deep(.image-config) {
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .uploadImg-cont {
    margin-top: 20px;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.btns {
  justify-content: center;
  align-items: center;
  button {
    width: 120px;
    height: 50px;
  }
}
</style>
